import * as React from "react";
import { Spinner } from "components/common";
import CorrelationSummary from "event-correlation/CorrelationSummary";
import SigmaCorrelationLicenseStatus from "./SigmaCorrelationLicenseStatus";
import useSigmaCorrelationLicenseStatus from "./hooks/useSigmaCorrelationLicenseStatus";
const SigmaCorrelationSummaryContainer = ({ ...otherProps }) => {
  const licenseStatus = useSigmaCorrelationLicenseStatus();
  if (licenseStatus.loading) {
    return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading Sigma correlation information..." });
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SigmaCorrelationLicenseStatus, { licenseStatus }), /* @__PURE__ */ React.createElement(CorrelationSummary, { ...otherProps }));
};
export default SigmaCorrelationSummaryContainer;
